export const reduce =
  <T, U>(transformer: (acc: U, value: T, index: number, array: T[]) => U, initial: U) =>
  (array: T[]): U =>
    array.reduce(transformer, initial)
